import StudiesMapper from '@/shared/mappings/study-mapper';
import { IOffering, IStudy, IStudyId } from '@/shared/models/api/study-model';

class StudiesService {
    public studiesMapper = new StudiesMapper();

    constructor() {}

    public getOfferingsByStudy = (language: string, studyId: string, HttpService: any): Promise<any> => {
        return this.getOfferings(this.offeringsByStudyQuery(language, studyId), HttpService);
    }

    public getCurrentStudiesByType = (language: string, type: string, HttpService: any): Promise<any> => {
        return this.getStudies(this.currentStudiesByTypeQuery(language, type), HttpService);
    }

    public getNextStudiesByType =  (language: string, type: string, HttpService: any): Promise<any> => {
        return this.getStudies(this.nextStudiesByTypeQuery(language, type), HttpService);
    }

    public getStudyIdByType =  (type: string, HttpService: any): Promise<any> => {
        return this.getStudyId(this.studyIdByTypeQuery(type), HttpService);
    }

    public getOfferings = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IOffering[]) => {
                resolve(result.map((entry: IOffering) => this.studiesMapper.mapOffering(entry)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }
    
    public getStudies = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IStudy[]) => {
                resolve(result.map((entry: IStudy) => this.studiesMapper.mapStudy(entry)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    public getStudyId = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IStudyId) => {
                resolve(this.studiesMapper.mapStudyId(result));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }
    
    public offeringsByStudyQuery = (language: string, studyId: string): string => {
        return `/api/studies/${language}/studies/${studyId}/offerings`;
    }
    
    public currentStudiesByTypeQuery = (language: string, type: string): string => {
        return `/api/studies/${language}/academicyears/current/studies?studyType=${type}`;
    }

    public nextStudiesByTypeQuery = (language: string, type: string): string => {
        return `/api/studies/${language}/academicyears/next/studies?studyType=${type}`;
    }
    
    public allStudiesQuery = (language: string, type: string): string => {
        return `/api/studies/${language}/studies`;
    }

    public studyIdByTypeQuery = (type: string): string => {
        return `/api/studies/studyids/${type}`;
    }
}

export default new StudiesService();